import { useEffect, useRef } from 'react';
import { useAtom } from 'jotai';
import { localStorageBridge } from 'shared/src/utils';
import { marketRankingFilterAtom } from '../states/marketRankingFilter.atom';
import { useMarketRankingTypes } from '../queries/useMarketRankingTypes';

const STORAGE_KEY = 'home_market_ranking_last_selected_market_type_sno';

/**
 * 마지막으로 선택한 마켓 타입을 로컬스토리지에 저장/복원.
 *
 * - 마운트 시 atom이 비어있고 딥링크 지정값도 없으면 저장된 sno로 복원
 * - `filter.selectedMarketType`이 바뀔 때마다 저장
 */
export const usePersistSelectedMarketType = (
  deeplinkMarketTypeSno: string | undefined,
) => {
  const { data: typesData } = useMarketRankingTypes();
  const [filter, setFilter] = useAtom(marketRankingFilterAtom);
  const hasRestoredRef = useRef(false);

  useEffect(() => {
    if (hasRestoredRef.current) return;
    hasRestoredRef.current = true;

    if (filter.selectedMarketType != null) return;
    if (deeplinkMarketTypeSno != null) return;

    localStorageBridge.getInt(STORAGE_KEY).then(sno => {
      if (sno == null) return;
      const matched = typesData.market_types.find(t => t.sno === sno);
      if (matched == null) return;
      setFilter(prev => {
        if (prev.selectedMarketType != null) return prev;
        return { ...prev, selectedMarketType: matched };
      });
    });
  }, [
    deeplinkMarketTypeSno,
    filter.selectedMarketType,
    setFilter,
    typesData.market_types,
  ]);

  useEffect(() => {
    if (filter.selectedMarketType == null) return;
    localStorageBridge.putInt(STORAGE_KEY, filter.selectedMarketType.sno);
  }, [filter.selectedMarketType]);
};
